import { useTranslation } from 'react-i18next';
import { useChangeCurrency } from 'react-easyrocket';
import { Button } from 'src/components/Buttons/Button';
import { ModalWrapper } from 'src/components/ModalWrapper';
import { useModalContext } from 'src/hooks/useModalContext';
import { useQueryClient } from '@tanstack/react-query';

const ChangeCurrencyModal = () => {
  const { modalProps, closeModal } = useModalContext<{ currency: string }>();
  const { mutate: changeCurrency, isLoading } = useChangeCurrency();
  const { t } = useTranslation();

  const queryClient = useQueryClient();

  const handleChangeCurrencyButton = async () => {
    await changeCurrency({
      currency: modalProps?.currency as string
    });
    queryClient.resetQueries({ queryKey: ['deposit-methods'] });
    closeModal();
  };

  return (
    <ModalWrapper className="h-auto">
      <div className="p-[20px] flex flex-col gap-5 items-center w-[300px] r_xsm:w-full">
        <p className="font-bold text-[16px] text-center text-mg_text">
          {t('accountWalletBalance.changeCurrencyTitle')}
        </p>
        <Button
          title={`${t('general.cancel')}`}
          mode="button-secondary"
          onClick={() => {
            closeModal();
          }}>
          {t('general.cancel')}
        </Button>
        <Button
          title={`${t('accountWalletBalance.changeCurrencyButton')}`}
          loading={isLoading}
          onClick={handleChangeCurrencyButton}
          mode="button-primary">
          {t('accountWalletBalance.changeCurrencyButton')}
        </Button>
      </div>
    </ModalWrapper>
  );
};

// eslint-disable-next-line no-restricted-exports
export default ChangeCurrencyModal;
